import { NgModule } from '@angular/core';


import { PatternService } from "./pattern.service";

@NgModule({
    providers: [PatternService]
})
export class PatternModule {}